module.exports = __webpack_public_path__ + "static/img/page41.197b1a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page41.png
// module id = eQ4Q
// module chunks = 0